export const DUMMY_FLIGHTS = [
  {
    id: 'NX-101',
    airline: 'SkyWay Airlines',
    code: 'SW',
    depart: '06:15',
    arrive: '09:05',
    duration: '4h 50m',
    stops: 0,
    price: 189,
    badge: 'Lowest fare',
    seats: 4,
  },
  {
    id: 'NX-214',
    airline: 'MetroJet',
    code: 'MJ',
    depart: '08:40',
    arrive: '12:10',
    duration: '5h 30m',
    stops: 1,
    stopCode: 'DEN',
    price: 214,
    badge: 'Best value',
    seats: 7,
  },
  {
    id: 'NX-332',
    airline: 'Liberty Air',
    code: 'LA',
    depart: '11:25',
    arrive: '14:30',
    duration: '5h 05m',
    stops: 0,
    price: 238,
    badge: 'Recommended',
    seats: 3,
  },
  {
    id: 'NX-408',
    airline: 'Coastline Airways',
    code: 'CA',
    depart: '14:50',
    arrive: '19:20',
    duration: '6h 30m',
    stops: 1,
    stopCode: 'PHX',
    price: 201,
    badge: 'Flexible fare',
    seats: 8,
  },
  {
    id: 'NX-517',
    airline: 'Bluebird Aviation',
    code: 'BA',
    depart: '17:35',
    arrive: '20:40',
    duration: '5h 05m',
    stops: 0,
    price: 259,
    badge: 'Evening flight',
    seats: 5,
  },
  {
    id: 'NX-625',
    airline: 'National Connect',
    code: 'NC',
    depart: '20:10',
    arrive: '01:15',
    duration: '7h 05m',
    stops: 1,
    stopCode: 'DFW',
    price: 176,
    badge: 'Late deal',
    seats: 2,
  },
];
